import { CheckinAndMaxAdvancedBooking } from "../../../Login/typings/login.types";

export const generateRowContents = (
  setting: CheckinAndMaxAdvancedBooking,
  t: (key: string, options?: any) => string
): string => {
  let mainContent = "";

  // 1. if allowedBookingDaysInAdvance exists, display it first in 'day' unit
  if (
    setting.allowedBookingDaysInAdvance !== null &&
    setting.allowedBookingDaysInAdvance !== undefined
  ) {
    const dayStr = setting.allowedBookingDaysInAdvance > 1 ? "days" : "day";
    mainContent = `${setting.allowedBookingDaysInAdvance} ${t(dayStr)}`;
  }
  // 2. otherwise, display maxWeeksInAdvance in 'weeks' unit
  else if (setting.maxWeeksInAdvance !== undefined) {
    mainContent = `${setting.maxWeeksInAdvance} ${t("weeks")}`;
  }

  // 3. if weekday and time exist, add
  // i.g. "6 Weeks, Monday, (08:00)"
  if (setting.weekday) {
    const dayStr = t(setting.weekday);
    mainContent += `, ${dayStr}`;
  }
  if (setting.time) {
    mainContent += `, (${setting.time})`;
  }

  return mainContent ?? "";
};
